import styled from 'styled-components'; 
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

export const CustomKeyboardDiv = styled.div
    `
    padding: 0 8px 0 3%;
    display: flex;
    justify-content: flex-end;
    flex-direction: row;
    flex-wrap: wrap;
    `
;

export const LinkIcon = styled(OpenInNewIcon) ``;

export const KeyboardButton = styled.div<{ color: string; link?: boolean }>
    `
    cursor:pointer;
    margin: 0 5px 10px 5px;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    border: 1px solid;
    border-radius: 20px;
    font-size: 13px;
    border-color: ${props => props.color};
    color: ${props => props.color};
    word-break: break-word;
    text-align: center;
    max-width: 100%;
    text-decoration: ${props => props.link ? 'underline' : 'none'};

    &:hover {
        opacity: 0.5;
    }

    ${LinkIcon} {
        font-size: 16px;
        padding: 0 5px 0 0;
        color: ${props => props.color};
    }
    `
;